import * as yup from "yup";
const validations = yup.object().shape({
  name: yup.string().required("validationMessages.required"),
  category: yup.string().required("validationMessages.required"),
  showcases: yup.array().min(1, "validationMessages.required"),
  sale_area: yup.string().required("validationMessages.required"),
});

export default validations;
